import request from '@/utils/request'
import store from '../store'

export function sendSMSCaptcha(item) {
  item['count'] = store.getters.smsCount
  store.commit('INCR_SMS_COUNT')
  return request({
    url: '/auth/send_sms',
    method: 'post',
    data: item
  })
}

export function loginByMobile(item) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: item
  })
}

export function register(item) {
  return request({
    url: '/auth/reg',
    method: 'post',
    data: item
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/auth.js